import { Lightning } from '@lightningjs/sdk';
import QrCode from 'components/common/QrCode';

export interface SettingsQrCodeSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  url: string;

  QrCode: typeof QrCode;
}

const SECTION_WIDTH = 802;

const QR_CODE_SIZE = 240;
const QR_CODE_SPACING = 8;

export default class SettingsQrCodeSection
  extends Lightning.Component<SettingsQrCodeSectionTemplateSpec>
  implements
    Lightning.Component
      .ImplementTemplateSpec<SettingsQrCodeSectionTemplateSpec>
{
  private _url = '';
  private _QrCode = this.getByRef('QrCode')!;

  set url(value: string) {
    this._url = value;
  }

  static override _template(): Lightning.Component.Template<SettingsQrCodeSectionTemplateSpec> {
    return {
      flex: { direction: 'column' },
      w: SECTION_WIDTH,
      QrCode: {
        type: QrCode,
        width: QR_CODE_SIZE,
        height: QR_CODE_SIZE,
        flexItem: {
          marginTop: QR_CODE_SPACING,
        },
      },
    };
  }

  override _active() {
    this._QrCode.load(this._url);
  }
}
